import styled from 'styled-components';

import { TIER_MEMBER, LITE_MEMBER, HOLLA_MEMBER } from '../../config/media';

const MembershipDetailsWrapper = styled.div`
	margin: 0px 15px;
	.title {
		font-size: 20px;
		font-weight: bold;
		color: #000000;
	}
	.sub-title {
		font-size: 12px;
		color: #000000;
	}
	.box-container {
		width: 100%;
		display: flex;
		flex-direction: column;
    	margin: 1rem 0;
		.content-wrapper {
			display: flex;
		}		
		.content {
			display: flex;
			flex-direction: column;
			align-items: center;
    		padding: 1rem 2rem;
			border: 1px solid #C4C4C4;
			h3, .stake-label {
				margin-top: 1rem;
				font-weight: bold;
				color: #000000
			}
			.inner-content {
				margin: 1rem 0;
    			// height: 24rem;
				.sub-header {
					font-weight: bold;
					color: #000000;
					text-align: center;
				}
			}
			.stake-wrapper {
				height: 4rem;
				text-align: center;
				.small-description {
					font-size: 12px;
					font-weight: bold;
					color: #000000;
					text-align: center;
				}
			}
			.ant-divider {
				width: 50% !important;
    			min-width: 0;
    			margin: 0;
			}
			.small-text {
				font-size: 12px;
				text-align: center;
			}
			.footer-description {
				font-size: 12px;
    			margin-bottom: 10px;
			}
		}
		.member-tier-img {
			background-size: cover;
			background-position: center;
			background-repeat: no-repeat;
			display: flex;
			flex-direction: column;
			justify-content: flex-end;
			height: 150px;
			padding: 1rem;
			width: 150px;

			.tier-img-title {
				font-size: 36px;
				font-weight: bold;
			}
			.tier-img-description {
				font-size: 10px;
			}
		}
		.member-img-tier {
			background-image: url(${TIER_MEMBER});
			color: #000000;
		}
		.member-img-lite {
			background-image: url(${LITE_MEMBER});
			color: #FFFFFF;
		}
		.member-img-holla {
			background-image: url(${HOLLA_MEMBER});
			color: #FFFFFF;
		}
		.membership-container {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			height: 100%;
		}
		.center-wrapper {
			display: flex;
			flex-direction: column;
			align-items: center;
		}
		.footer-content {
			height: 250px;
			display: flex;
			flex-direction: column;
			align-items: center;
			text-align: center;
		}
		.member-tier-head {
			height: 125px;
			text-align: center;
		}
	}
	.btn-wrapper {
		display: flex;
		.ant-btn {
			width: 100%;
			height: 40px;
			margin-top: 1rem;
		}
		.separator {
			margin: 1rem;
		}
	}
	.text-center {
		text-align: center;
	}
	@media (max-width: 960px) {
		.box-container {
			.content-wrapper {
				flex-wrap: wrap;
				justify-content: space-around;
			}
			.content {
				margin-bottom: 1rem;
				width: min-content;	
			}
		}
		.btn-wrapper {
			margin-bottom: 2rem;
			.ant-btn {
				width: 100%;
				height: 40px;
				margin-top: 1rem;
				white-space: normal;
			}
			.separator {
				margin: 5px;
			}
		}
	}
`
export default MembershipDetailsWrapper;
